class Controller {
	static init() {}
	static updateLocale() {}
}

export default Controller;
